import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "input-items" }
const _hoisted_2 = { class: "mt-2 d-flex w-100" }

import InputWrapperWithIcon from "~/chat/vue/widget/form/fields/InputWrapperWithIcon.vue";
import {useChatFormInput, useChatFormInputProps} from "~/chat/vue/widget/form/fields/useChatFormInput";
import {computed} from "vue";
import {CLIENT_DATA_TYPE_DATETIME} from "~/chat/ts/data/IClient";
import ChatSelectInput from "~/chat/vue/widget/form/fields/ChatSelectInput.vue";
import DateHelper from "~/ts/library/Date";
import {createTimeSelect, numberToStringWithZero} from "~/chat/vue/widget/form/fields/ChatTimeInputHelper";



import {defineAsyncComponent} from "vue";

const __default__ = {
    name: "ChatDateInput",
    components: {
        VueDatePick: defineAsyncComponent(() => import(/* webpackChunkName: "date-input" */ '~/chat/vue/widget/form/fields/vueDatePick.vue')),
    }
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps()
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let {exposedObject} = useChatFormInput(props);

__expose(exposedObject);

let isDateTime = computed(() => props.field.type == CLIENT_DATA_TYPE_DATETIME);

function modifyAndEmitModel(modify: (date: Date, value?: string) => void, value?: string) {
    let modelValue = new Date(props.modelValue ?? new Date());
    modify(modelValue, value);
    modelValue.setSeconds(0);
    let helper = new DateHelper(modelValue);
    emits("update:modelValue", isDateTime.value ? helper.toMysqlFormat() : helper.toMysqlFormatDate());
}

function emitInput(value: string) {
    if (value) {
        let valueArray = value.split('.');
        modifyAndEmitModel(date => {
            date.setFullYear(parseInt(valueArray[2]));
            date.setMonth(parseInt(valueArray[1]) - 1);
            date.setDate(parseInt(valueArray[0]));
        })
    } else {
        emits("update:modelValue", null);
    }
}

let russianValue = computed(() => {
    let value: string = props.modelValue;
    if (value) {
        let valueArray = value.split(" ")[0].split("-");
        value = `${valueArray[2]}.${valueArray[1]}.${valueArray[0]}`;
    }
    return value;
});

let hourSelect = createTimeSelect(23);
let minuteSelect = createTimeSelect(59);

function getTimeSegment(index: number) {
    let value = props.modelValue?.split(" ")[1]?.split(":")[index];
    if (value) {
        value = parseInt(value);
    }
    if (!Number.isInteger(value)) {
        value = 0;
    }
    return numberToStringWithZero(value);
}

function createTimeComputed(index: number, modify: (date: Date, value: string) => void) {
    return computed({
        get: () => {
            return getTimeSegment(index);
        },
        set: (value: string) => {
            modifyAndEmitModel(modify, value);
        }
    })
}


let hour = createTimeComputed(0, (date, value) => {
    date.setHours(parseInt(value));
});

let minutes = createTimeComputed(1, (date, value) => {
    date.setMinutes(parseInt(value));
});

return (_ctx: any,_cache: any) => {
  const _component_vue_date_pick = _resolveComponent("vue-date-pick")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(InputWrapperWithIcon, {
          field: _ctx.field,
          required: _ctx.required,
          class: "flex-fill"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_vue_date_pick, {
              "model-value": _unref(russianValue),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emitInput($event))),
              format: "DD.MM.YYYY",
              "input-attributes": {
                            class: _ctx.field.icon ? 'with-icon' : null,
                            placeholder: _ctx.field.descr
                        }
            }, null, 8, ["model-value", "input-attributes"])
          ]),
          _: 1
        }, 8, ["field", "required"]),
        (_unref(isDateTime))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(ChatSelectInput, {
                modelValue: _unref(hour),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(hour) ? (hour).value = $event : hour = $event)),
                field: _unref(hourSelect),
                class: "time-select"
              }, null, 8, ["modelValue", "field"]),
              _createVNode(ChatSelectInput, {
                modelValue: _unref(minutes),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(minutes) ? (minutes).value = $event : minutes = $event)),
                field: _unref(minuteSelect),
                class: "time-select"
              }, null, 8, ["modelValue", "field"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})